import { render, staticRenderFns } from "./examine.vue?vue&type=template&id=fb2f6734&scoped=true"
import script from "./examine.vue?vue&type=script&lang=js"
export * from "./examine.vue?vue&type=script&lang=js"
import style0 from "./examine.vue?vue&type=style&index=0&id=fb2f6734&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2f6734",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb2f6734')) {
      api.createRecord('fb2f6734', component.options)
    } else {
      api.reload('fb2f6734', component.options)
    }
    module.hot.accept("./examine.vue?vue&type=template&id=fb2f6734&scoped=true", function () {
      api.rerender('fb2f6734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/logisticsSystem/InternalDelivery/examine/examine.vue"
export default component.exports